import { filterPropertiesByNeighborhood } from "./mapViewStorage";
import { filterParentProperties } from "../../../utils/propertyDisplay";

export interface ListPropertyResolution<T> {
  properties: T[];
  appliedNeighborhood: string | null;
  fellBackToCity: boolean;
}

export function isPropertyInNeighborhood(
  property: { address?: { neighborhood?: string } },
  neighborhood: string | null | undefined
): boolean {
  if (!neighborhood) {
    return false;
  }

  return (
    property.address?.neighborhood?.toLowerCase() === neighborhood.toLowerCase()
  );
}

export function resolveListProperties<
  T extends {
    address?: { neighborhood?: string };
    parent_property_id?: number | string | null;
  }
>(
  allProperties: T[],
  neighborhood: string | null | undefined
): ListPropertyResolution<T> {
  const parentOnlyProperties = filterParentProperties(allProperties);

  if (!neighborhood) {
    return {
      properties: parentOnlyProperties,
      appliedNeighborhood: null,
      fellBackToCity: false,
    };
  }

  const neighborhoodMatches = filterPropertiesByNeighborhood(
    parentOnlyProperties,
    neighborhood
  );

  if (neighborhoodMatches.length > 0) {
    return {
      properties: neighborhoodMatches,
      appliedNeighborhood: neighborhood,
      fellBackToCity: false,
    };
  }

  return {
    properties: parentOnlyProperties,
    appliedNeighborhood: null,
    fellBackToCity: true,
  };
}
